import * as Sentry from '@sentry/browser';
import { Dedupe as DedupeIntegration } from '@sentry/integrations';

import { isPayApp, MATRIX_DSN, RELEASE } from '~/utils/appInfo';

type CaptureExceptionProps = {
  error: Error;
  level: Sentry.SeverityLevel;
  message?: string;
};

const SENTRY_TAG_APP_TYPE = {
  PAYAPP: 'PAYAPP',
  EXTERNAL_BROWSER: 'EXTERNAL_BROWSER',
} as const;

const setGlobalScope = async () => {
  try {
    Sentry.configureScope((scope) => {
      scope.setTags({
        appType: isPayApp
          ? SENTRY_TAG_APP_TYPE.PAYAPP
          : SENTRY_TAG_APP_TYPE.EXTERNAL_BROWSER,
      });
    });
  } catch (error) {
    Sentry.captureException(error);
  }
};

export const initSentry = () => {
  Sentry.init({
    dsn: MATRIX_DSN,
    release: RELEASE,
    environment: RELEASE,
    normalizeDepth: 6,
    tracesSampleRate: 1,
    integrations: [
      new Sentry.Integrations.Breadcrumbs({ console: true }),
      new DedupeIntegration(),
    ],
  });

  setGlobalScope();
};

export const captureGlobalException = ({
  error,
  level,
  message,
}: CaptureExceptionProps) => {
  Sentry.withScope((scope: Sentry.Scope) => {
    scope.setLevel(level);
    scope.setFingerprint([error.name, message ?? error.message]);
    Sentry.captureException(error);
  });
};
